import React, { cloneElement, Fragment } from 'react';
import { Building2, TrendingUp, ClipboardCheck, Boxes, Hammer, BarChart2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
const ICONS = [<Building2 className="w-5 h-5 text-navy" data-id="element-104" />, <TrendingUp className="w-5 h-5 text-navy" data-id="element-105" />, <ClipboardCheck className="w-5 h-5 text-navy" data-id="element-106" />, <Boxes className="w-5 h-5 text-navy" data-id="element-107" />, <Hammer className="w-5 h-5 text-navy" data-id="element-108" />, <BarChart2 className="w-5 h-5 text-navy" data-id="element-109" />];
export function ServicesSection() {
  const {
    t
  } = useLanguage();
  const services = t.servicesPreview.cards.map((card, i) => ({
    icon: ICONS[i],
    title: card.title,
    description: card.description
  }));
  return <section className="w-full bg-white py-24" data-id="element-110">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-111">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-112">
          <span className="text-brandOrange text-xs font-bold tracking-[0.15em] uppercase mb-4 block" data-id="element-113">
            {t.servicesPreview.eyebrow}
          </span>
          <h2 className="text-3xl lg:text-[34px] font-poppins font-bold text-navy leading-tight" data-id="element-114">
            {t.servicesPreview.heading.map((line, i) => <Fragment key={i} data-id="element-115">
                {line}
                {i < t.servicesPreview.heading.length - 1 && <br data-id="element-116" />}
              </Fragment>)}
          </h2>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-117">
          {services.map((service, index) => <div key={index} className="group bg-white border border-borderColor rounded-xl p-8 hover:-translate-y-1 hover:shadow-xl hover:shadow-brandOrange/5 hover:border-brandOrange/40 transition-all duration-300 cursor-pointer" data-id="element-118">
              <div className="w-10 h-10 rounded bg-gray-50 group-hover:bg-brandOrange/10 transition-colors duration-300 flex items-center justify-center mb-6" data-id="element-119">
                {cloneElement(service.icon as React.ReactElement, {
              className: 'w-5 h-5 text-gray-400 group-hover:text-brandOrange transition-colors duration-300'
            })}
              </div>
              <h3 className="text-navy font-bold text-[13px] uppercase tracking-wide mb-3 group-hover:text-brandOrange transition-colors duration-300" data-id="element-120">
                {service.title}
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-121">
                {service.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}